import React, {FC} from 'react'
import {Link} from 'react-router-dom'

type SetupCard = {
  category: string
  icon: string
  title: string
  description: string
  buttonLabel: string
  to: string
}

const setupCards: SetupCard[] = [
  {
    category: 'Organization',
    icon: '👥',
    title: 'Invite Your Team',
    description:
      'Invite your team to use Commercium with granular roles and permissions to manage operations.',
    buttonLabel: 'Invite Users',
    to: '/manage-user-roles',
  },
  {
    category: 'Sales',
    icon: '🔌',
    title: 'Connect Sales Channels',
    description:
      'Link your Amazon, Shopify, or eBay accounts to begin syncing orders and inventory levels automatically.',
    buttonLabel: 'Configure Channels',
    to: '/platforms?nature=all',
  },
  {
    category: 'Fulfillment',
    icon: '🚚',
    title: 'Shipping Integrations',
    description:
      'Integrate with ShipHero or Amazon MCF to automate fulfillment and shipping label workflows.',
    buttonLabel: 'Set Up Shipping',
    to: '/platforms?nature=shipping',
  },
  {
    category: 'Finance',
    icon: '📊',
    title: 'Accounting Integration',
    description:
      'Connect QuickBooks, Xero, or Zoho Books to automate bookkeeping, tax calculations, and reporting.',
    buttonLabel: 'Connect Accounting',
    to: '/platforms?nature=accounting',
  },
  {
    category: 'Enterprise',
    icon: '⚙️',
    title: 'ERP Integration',
    description:
      'Sync with NetSuite, SAP Business One, or Microsoft Dynamics for enterprise-grade planning.',
    buttonLabel: 'Configure ERP',
    to: '/platforms?nature=erp',
  },
  {
    category: 'Support',
    icon: '💬',
    title: 'Get Help',
    description: 'Visit the support center for guides, tickets, and onboarding assistance.',
    buttonLabel: 'Open Support',
    to: '/support',
  },
]

const GetGoingTab: FC = () => {
  return (
    <>
      <div className='dashboard-getgoing-hero'>
        <h2>Welcome to Commercium</h2>
        <p>
          Your complete multi-channel inventory and order management hub. Connect your store and
          start syncing inventory in just a few minutes.
        </p>
        <a
          href='https://constacloud.com/commercium/'
          target='_blank'
          rel='noopener noreferrer'
          className='text-primary fw-bold fs-7 mt-2 d-inline-block'
        >
          Overview of Commercium
        </a>
      </div>

      <div className='dashboard-setup-grid'>
        {setupCards.map((card) => (
          <div key={card.title} className='dashboard-setup-card'>
            <div className='dashboard-setup-header'>
              <div className='dashboard-setup-header-main'>
                <span className='dashboard-setup-tag'>{card.category}</span>
                <h3>{card.title}</h3>
              </div>
              <div className='dashboard-setup-icon'>{card.icon}</div>
            </div>
            <p>{card.description}</p>
            <Link to={card.to} className='dashboard-setup-btn'>
              {card.buttonLabel}
            </Link>
          </div>
        ))}
      </div>
    </>
  )
}

export default GetGoingTab
